import React from "react"
import PropTypes from "prop-types"

import CardWithIconTextDescriptionTwo from "@components/CardWithIconTextDescriptionTwo"

const CardWithIconTextDescriptionModuleTwo = ({
  title,
  firstIcon,
  firstIconTitle,
  firstIconDescription,
  secondIcon,
  secondIconTitle,
  secondIconDescription,
  thirdIcon,
  thirdIconTitle,
  thirdIconDescription,
}) => {
  return (
    <div className="py-10 px-6 md:px-11 xl:px-25 xl:pt-25 xl:pb-25 bg-lblue">
      <div className="mx-auto max-w-screen-fhd">
        <h2
          className="text-dblue font-inter text-20 xl:text-40
      font-normal leading-120% xl:leading-normal mb-9 
      md:mb-8 xl:mb-[48px] md:max-w-[448px] xl:max-w-[66%] xl:font-medium"
        >
          {title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-9 md:gap-4 xl:gap-[32px]">
          <CardWithIconTextDescriptionTwo
            icon={firstIcon}
            title={firstIconTitle}
            description={firstIconDescription}
          />
          <CardWithIconTextDescriptionTwo
            icon={secondIcon}
            title={secondIconTitle}
            description={secondIconDescription}
          />
          <CardWithIconTextDescriptionTwo
            icon={thirdIcon}
            title={thirdIconTitle}
            description={thirdIconDescription}
          />
        </div>
      </div>
    </div>
  )
}

CardWithIconTextDescriptionModuleTwo.propTypes = {
  title: PropTypes.string,
  firstIcon: PropTypes.string,
  firstIconTitle: PropTypes.string,
  firstIconDescription: PropTypes.string,
  secondIcon: PropTypes.string,
  secondIconTitle: PropTypes.string,
  secondIconDescription: PropTypes.string,
  thirdIcon: PropTypes.string,
  thirdIconTitle: PropTypes.string,
  thirdIconDescription: PropTypes.string,
}

export default CardWithIconTextDescriptionModuleTwo
